module.exports = __webpack_public_path__ + "static/media/SnowballNFTRollingPurple.53129071.gif";